import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { TableEditColumn } from '@devexpress/dx-react-grid-material-ui';

const KebabCommandCell = ({ children, ...restProps }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  let editCommand;

  React.Children.forEach(children, (child) => {
    if (child?.props?.id === 'edit') {
      editCommand = child.props.onExecute;
    }
  });

  const handleOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event?.stopPropagation?.();
    setAnchorEl(null);
  };

  const handleEdit = (event) => {
    event.stopPropagation();
    handleClose();
    editCommand?.();
  };

  if (!editCommand) {
    return <TableEditColumn.Cell {...restProps}>{children}</TableEditColumn.Cell>;
  }

  return (
    <TableEditColumn.Cell
      {...restProps}
      onClick={(event) => event.stopPropagation()}
      onDoubleClick={(event) => event.stopPropagation()}
      style={{ ...restProps.style, textAlign: 'center' }}
    >
      <IconButton aria-label="qualification actions" onClick={handleOpen} size="small">
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={(event) => event.stopPropagation()}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <MenuItem onClick={handleEdit}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>
      </Menu>
    </TableEditColumn.Cell>
  );
};

KebabCommandCell.propTypes = {
  children: PropTypes.node
};

export default KebabCommandCell;
